// sidebar
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'
export const TOGGLE_CATEGORY = 'TOGGLE_CATEGORY'

// currentTrack
export const LOAD_TRACK = 'LOAD_TRACK'
export const TOGGLE_CURRENT_TRACK = 'TOGGLE_CURRENT_TRACK'
export const TICK_CURRENT_TRACK = 'TICK_CURRENT_TRACK'
export const SEEK_CURRENT_TRACK = 'SEEK_CURRENT_TRACK'
export const UNSEEK_CURRENT_TRACK = 'UNSEEK_CURRENT_TRACK'
export const SET_VOLUME = 'SET_VOLUME'

// audioPlayer
export const SET_HTML5 = 'SET_HTML5'
export const SET_SOURCE = 'SET_SOURCE'

// all tracks
export const RECEIVE_TRACKS = 'RECEIVE_TRACKS'
export const CHAPTER_SEARCH = 'CHAPTER_SEARCH'

// track caching
export const SET_TRACK_CACHED = 'SET_TRACK_CACHED'



// WEBPACK FOOTER //
// ./src/actions/types.js